module.exports = __webpack_public_path__ + "static/makefile-148d397880b06b049bc9abdcc739e57d.png";